import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_HOST } from "../../constants";

const normalizeTag = (value) => value.replace(/^#/, "").trim();

function TagInput({ value = [], onChange }) {
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const tags = useMemo(() => value.map((tag) => normalizeTag(tag)), [value]);

  useEffect(() => {
    if (!input.trim()) {
      setSuggestions([]);
      return;
    }

    const query = normalizeTag(input);
    axios
      .get(`${API_HOST}/api/tags/`, { params: { query, order: "latest" } })
      .then((response) => setSuggestions(response.data))
      .catch(() => setSuggestions([]));
  }, [input]);

  const addTag = (raw) => {
    const tag = normalizeTag(raw);
    if (!tag) return;
    const exists = tags.some((item) => item.toLowerCase() === tag.toLowerCase());
    if (exists) {
      setInput("");
      return;
    }
    onChange([...tags, tag]);
    setInput("");
  };

  const removeTag = (tagToRemove) => {
    onChange(tags.filter((tag) => tag.toLowerCase() !== tagToRemove.toLowerCase()));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      addTag(input);
    }
    if (event.key === "Backspace" && !input && tags.length) {
      removeTag(tags[tags.length - 1]);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span key={tag} className="chip chip-active">
            #{tag}
            <button
              type="button"
              onClick={() => removeTag(tag)}
              className="ml-2 text-xs text-white/60 hover:text-white"
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <div className="relative">
        <input
          className="soft-input"
          placeholder="#태그를 입력하고 스페이스 또는 Enter"
          value={input}
          onChange={(event) => setInput(event.target.value)}
          onKeyDown={handleKeyDown}
        />
        {suggestions.length > 0 && (
          <div className="absolute left-0 right-0 top-full z-10 mt-2 max-h-48 overflow-auto rounded-xl border border-white/10 bg-ink-900/95 p-2 text-sm text-ink-200 shadow-card">
            {suggestions.map((tag) => (
              <button
                key={tag.id}
                type="button"
                onClick={() => addTag(tag.name)}
                className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-left hover:bg-white/5"
              >
                <span>#{tag.name}</span>
                <span className="text-xs text-ink-200">추천</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TagInput;
